import { getDeliveryContentApi } from '@/api/tool/delivery-content';

/**
 * 投放内容混入
 * @param {Class} Base 基类
 */
export default (Base) => class extends Base {
  /**
   * 获取投放内容
   * @param {string} advertiser_id 广告主id
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        filtering,
      };
      const ret = await getDeliveryContentApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: `${name}（${id}）`, value: `${id}#${name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
};
